import { MenuItem, Typography } from '@material-ui/core'
import React from 'react'
import PropTypes from 'prop-types'

// Auto complete
export const RegisterSuggestionItem = ({
  getSuggestionItemProps,
  onSelectPlaceSuggestion,
  suggestion,
  clickedSuggestion,
}) => {
  const { formattedSuggestion, description } = suggestion

  return (
    <MenuItem
      component="div"
      {...getSuggestionItemProps(suggestion, {
        className: `bg-white hover:bg-grey-light`,
        onClick: onSelectPlaceSuggestion(suggestion),
      })}
    >
      <div
        onClick={() => {
          clickedSuggestion && clickedSuggestion(suggestion)
        }}
        className="flex flex-col"
      >
        <Typography color="primary">{formattedSuggestion.mainText}</Typography>
        <Typography>{description}</Typography>
      </div>
    </MenuItem>
  )
}

RegisterSuggestionItem.propTypes = {
  suggestion: PropTypes.object.isRequired,
  getSuggestionItemProps: PropTypes.func.isRequired,
  onSelectPlaceSuggestion: PropTypes.func.isRequired,
}

export const RegisterSuggestionList = ({ suggestions, ...props }) => {
  return suggestions.map((suggestion) => (
    <RegisterSuggestionItem
      key={suggestion.placeId}
      suggestion={suggestion}
      {...props}
    />
  ))
}

RegisterSuggestionList.propTypes = {
  suggestions: PropTypes.array.isRequired,
  getSuggestionItemProps: PropTypes.func.isRequired,
  onSelectPlaceSuggestion: PropTypes.func.isRequired,
}
